import React, { useEffect } from 'react'
import Layout from 'components/LayoutForPortal'
import Title from 'components/Title'
import UserList from 'components/Table/BasicTable'

import { Form, Input, message } from 'antd';
import { useDispatch, useSelector } from 'react-redux'
import SelectFilter from 'components/Filters/CallFilters'
import { DataGetAction, DataRequestAction } from 'redux/actions/http';
import IntlMessages from "util/IntlMessages"
import ActionDropdown from 'components/Table/ActionDropdown'
import { intlPlaceholder } from "util/intlPlaceholder"
import { renderStatus } from "utils/commonUseFunction"
import ResetPasswordModal from './components/ResetPasswordModal'
const Index = () => {

    const [form] = Form.useForm();
    const dispatch = useDispatch()

    const userProps = useSelector(state => state.users)
    const { usersList, textMessage, apiFail, passwordChange, updateUserSuccess, userListSpinner } = userProps

    console.log('============usersList==========', usersList)


    const fetchUserList = () => {
        dispatch(DataGetAction('getUserList', { query: 'all' }, 'gettingUserListSpinner'));

    }
    useEffect(fetchUserList, [])



    const columns = [
        {
            title: <IntlMessages id="users.id" />,
            render: record => <span>{record.userId}</span>,
            key: "userId"
        },
        {
            title: <IntlMessages id="users.fullName" />,
            render: record => <span>{record.fullName}</span>,
            key: "firstName"
        },
        {
            title: <IntlMessages id="users.email" />,
            render: record => <span>{record.email}</span>,
            key: "email"
        },
        {
            title: <IntlMessages id="users.phone" />,
            render: record => <span>{record.phoneNumber}</span>,
            key: "phone"
        },
        {
            title: <IntlMessages id="users.membership" />,
            render: record => record.memberShipPlan === 'free' ? <span style={{ color: '#038fde' }}>{record.memberShipPlan}</span> : <span style={{ color: '#3FD4A2' }}>{record.memberShipPlan}</span>,
            key: "membership"
        },
        {
            title: <IntlMessages id="users.status" />,
            render: record => <span> {renderStatus(record.status)}</span>,
            key: "phone"
        },
        {
            title: '',
            render: (record) => <ActionDropdown menu={renderActions(record)}> </ActionDropdown>,
            key: "action"
        },
    ]


    const renderActions = (record) => {
        return <div className="gx-d-flex gx-flex-column">
            {(record.status === 'unBlock' || record.status === 'active') && <span onClick={() => updateStatus(record, 'block')} className="simple-link"><IntlMessages id="users.actions.block" /></span>}
            {record.status === 'block' && <span onClick={() => updateStatus(record, 'active')} className="simple-link"><IntlMessages id="users.actions.unBlock" /></span>}
            {record.status === 'block' && <span onClick={() => updateStatus(record, 'unBlockTemporary')} className="simple-link"><IntlMessages id="users.actions.unBlockTemporary" /></span>}
            <span onClick={() => openResetModal(record)} className="simple-link">   <IntlMessages id="users.actions.resetPassword" /> </span>
        </div>
    }

    const updateStatus = (record, status) => {



        dispatch(DataRequestAction('PUT', 'updateUserStatus', { userId: record._id, status: status }, '', 'blockingUser', false));
    }


    if (apiFail) {
        message.error(textMessage)
    }

    if (updateUserSuccess) {
        message.success(textMessage)
        dispatch({
            type: 'reset_Change'
        })
    }
    if (passwordChange) {
        message.success(textMessage)
        dispatch({
            type: 'reset_Change'
        })
        form.resetFields()
    }

    const openResetModal = (record) => {
        dispatch({
            type: 'ResetPassword_Modal',
            payload: record
        })
    }

    const handleTableChange = (pagination, filters, sorter) => {

       console.log('===========handleTableChange======',pagination,filters,sorter)
    }
    return (
        <Layout>

            <div className="gx-d-flex gx-flex-row gx-justify-content-between">
                <div className="gx-mb-2 gx-mb   -md-0">
                    <Title title={<IntlMessages id="Users.pageTitle" />} />
                </div>
                <div className="gx-d-flex gx-flex row">
                    <div className=" gx-mb-3 gx-mb-md-0">
                        <SelectFilter placeholder={<IntlMessages id="users.filter.filerbyMembership" />} isShowingAll={true} apiName="getUserList" searchKey="memberShip" options={[
                            { status: "free", label: "Free" },
                            { status: "premium", label: "Premium" },
                        ]} ItemValue="status" label="label" />
                    </div>
                    <div className="gx-my-0  gx-ml-2" style={{ width: '240px' }}>
                        <Input.Search
                            showSearch
                            placeholder={intlPlaceholder('users.filter.idandEmail')}
                            filterOption={false}
                            onChange={(e) => dispatch(DataGetAction('getUserList', { name: e.target.value }, ''))}
                        />
                    </div>


                </div>

            </div>


            <UserList loading={userListSpinner} data={userListSpinner ? [] : usersList} columns={columns}
                onChange={handleTableChange}
                pagination={{
                    total: usersList && usersList.length // total count returned from backend
                }}
            />

            <ResetPasswordModal />

        </Layout>
    )
}

export default Index
